export enum NavigationIds {
    EditorStart = "editorStart",
    AllSubContracts = "allSubContracts",
    DataSets = "dataSets",
    EntityGroups = "entityGroups",
    Entities = "entities",
    EntityDraftCreate = "entityDraftCreate",
    DataSetDraftCreate = "dataSetDraftCreate",
    DataSetDraftEdit = "dataSetDraftEdit",
    EntityGroupDraftCreate = "entityGroupDraftCreate",
    EntityGroupDraftEdit = "entityGroupDraftEdit"
}
